import { CategoryHeaderComponent } from './components/category-header/category-header.component';
import { CategoryComponent } from './components/category/category.component';
import { LoadingIndicatorComponent } from './components/loading-indicator/loading-indicator.component';
import { MobileCategoryPickerComponent } from './components/mobile-category-picker/mobile-category-picker.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { ProductFormOrderDialogComponent } from '@app/dialog/components/product-form-order-dialog/product-form-order-dialog.component';
import { ProductFormQuoteDialogComponent } from '@app/dialog/components/product-form-quote-dialog/product-form-quote-dialog.component';
import { IconComponent } from '@app/shared/components/icon/icon.component';
import { ProductListListComponent } from '@app/shared/components/product-list/product-list-list/product-list-list.component';
import { SelectComponent } from '@app/shared/components/select/select.component';
import { SorterComponent } from '@app/shared/components/sorter/sorter.component';
import { VatSelectorComponent } from '@app/shared/components/vat-selector/vat-selector.component';
import { ZoomableImageComponent } from '@app/shared/components/zoomable-image/zoomable-image.component';
import { SharedModule } from '@app/shared/shared.module';
import { DynamicUploadModule } from '@app/upload/upload.module';

const categoryRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild([
	{
		path: '',
		component: CategoryComponent,
	},
	{
		path: ':id',
		component: CategoryComponent,
	},
	{
		path: ':id/:name',
		component: CategoryComponent,
	},
]);

/** Category module. */
@NgModule({
	imports: [
		categoryRouting,
		SharedModule,
		VatSelectorComponent,
		IconComponent,
		ZoomableImageComponent,
		SelectComponent,
		SorterComponent,
		MatMenuModule,
		DynamicUploadModule,
	],
	declarations: [
		ProductFormQuoteDialogComponent,
		ProductFormOrderDialogComponent,
		ProductListListComponent,
		CategoryComponent,
		CategoryHeaderComponent,
		SidenavComponent,
		MobileCategoryPickerComponent,
		LoadingIndicatorComponent,
	],
})
export class CategoryModule {}
